const Header = ({
  mode,
  userlogin,
  canAssignRole,
  roles,
  formDataUser,
  handleChange,
  loading,
  notEditor,
}) => {
  if (mode === 'create') {
    return (
      <div className={`${canAssignRole ? 'flex flex-col' : ''} sm:flex-row sm:items-start sm:justify-between gap-4 mb-4 sm:mb-2`}>
        <h2 className="text-lg sm:text-xl font-semibold text-center mb-4 sm:mb-6 text-primary">
          Formulario de inscripción a la comunidad
        </h2>
        {canAssignRole && (
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Rol
            </label>
            <select
              name="role"
              value={formDataUser.role}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-primary-light focus:border-primary text-sm"
              disabled={loading || !canAssignRole}
              required
            >
              <option value="">
                {roles.length ? 'Selecciona una opción' : 'Cargando...'}
              </option>
              {roles.map((r) => (
                <option key={r.Id} value={r.Id}>
                  {r.Name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    );
  }
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-4 sm:mb-2">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 sm:mb-2">
        <div className="mx-auto sm:mx-0 mb-2 sm:mb-0 bg-personalized text-white rounded-full w-16 h-16 flex items-center justify-center flex-none font-bold text-2xl sm:text-3xl leading-none">
          {userlogin?.FirstName?.charAt(0)}
          {userlogin?.LastName?.charAt(0)}
        </div>
        <div className="text-center sm:text-left">
          <h2 className="text-lg sm:text-xl font-bold">
            {userlogin?.FirstName} {userlogin?.LastName ?? ''}
          </h2>
          <p className="text-gray-600 text-sm break-words">
            {userlogin?.PrincipalEmail}
          </p>
        </div>
      </div>
      {canAssignRole && (
        <div>
          <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
            Rol
          </label>
          <select
            name="role"
            value={formDataUser.role}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-primary-light focus:border-primary text-sm"
            disabled={loading || !canAssignRole}
            required
          >
            <option value="">
              {roles.length ? 'Selecciona una opción' : 'Cargando...'}
            </option>
            {roles.map((r) => (
              <option key={r.Id} value={r.Id}>
                {r.Name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default Header;
